export const menuStructure = {
  'SG': {
    name: 'SG(시나리오생성)',
    path: '/sg',
    component: 'SGMain',
    submenus: [
      { 
        id: 'overview', 
        name: '개요',
        path: '/sg/overview',
        component: 'SGMain'
      },
      { 
        id: 'usecase-scenario', 
        name: '위험(Hazard) 식별 및 평가',
        path: '/sg/usecase-scenario',
        component: 'UseCaseScenario'
      },
      { 
        id: 'scenario-analysis', 
        name: '위험 유발 트리거 이벤트 도출',
        path: '/sg/scenario-analysis',
        component: 'ScenarioManage'
      }
    ]
  },
  'DA': {
    name: 'DA(센서정보획득)',
    path: '/da',
    component: 'DAMain',
    submenus: [
      { 
        id: 'overview', 
        name: '개요',
        path: '/da/overview',
        component: 'DAMain'
      },
      {
        id: 'acquisition-status',
        name: '데이터획득현황',
        path: '/da/acquisition-status',
        component: 'AcquisitionStatus',
      },
      { 
        id: 'data-management', 
        name: '획득데이터관리',
        path: '/da/data-management',
        component: 'DataManagement'
      }
    ]
  },
  // 'ED': {
  //   name: 'ED(센서정보가공)',
  //   path: '/ed',
  //   component: 'EDMain',
  //   submenus: [
  //     { 
  //       id: 'overview', 
  //       name: '개요',
  //       path: '/ed/overview',
  //       component: 'EDMain'
  //     },
  //     { 
  //       id: 'processing', 
  //       name: '가공',
  //       path: '/ed/processing',
  //       component: 'Processing'
  //     }
  //   ]
  // },
  'EA': {
    name: 'EA(인지성능평가)',
    path: '/ea',
    component: 'EAManage',
    submenus: []
  },
  'Standard': {
    name: 'Standard(표준)',
    path: '/standard',
    component: 'Standard',
    submenus: []
  }
};